import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function MetricsSection() {
  return <SectionWrapper className="py-12 bg-white/40 border-y border-dusty-rose/20" data-id="element-161">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center" data-id="element-162">
        <MetricItem number="+500" text="mamás confían" data-id="element-163" />
        <MetricItem number="6+3" text="Tomos + Bonus" data-id="element-164" />
        <MetricItem number="4.9/5" text="calificación ⭐" data-id="element-165" />
        <MetricItem number="LATAM" text="para todo latinoamérica" data-id="element-166" />
      </div>
    </SectionWrapper>;
}
function MetricItem({
  number,
  text
}: {
  number: string;
  text: string;
}) {
  return <div className="flex flex-col items-center justify-center" data-id="element-167">
      <span className="text-4xl md:text-5xl font-black text-burgundy font-serif mb-2" data-id="element-168">
        {number}
      </span>
      <span className="text-sm md:text-base font-medium text-text-main/80 uppercase tracking-wider" data-id="element-169">
        {text}
      </span>
    </div>;
}